/**
 * @file
 * Behaviors for the Header.
 */

!((Drupal, $) => {
  'use strict';

  Drupal.behaviors.headerNavigation = {
    attach: function(context) {
      $('.lohkanguovddas-header__navigation-button', context).on(
        'click',
        function() {
          $(this).toggleClass('open');
          $('.lohkanguovddas-header__navigation').slideToggle(200);

          if ($(this).hasClass('open')) {
            $(this).attr('aria-expanded', 'true');
          }
          else {
            $(this).attr('aria-expanded', 'false');
          }
        }
      );
    }
  };

  Drupal.behaviors.headerLevels = {
    attach: function(context) {
      $('.lohkanguovddas-header__levels-button', context).on(
        'click',
        function() {
          $(this).toggleClass('open');
          $('.lohkanguovddas-header__levels').slideToggle(200);
          if ($(this).hasClass('open')) {
            $(this).attr('aria-expanded', 'true');
          }
          else {
            $(this).attr('aria-expanded', 'false');
          }
        }
      );
    }
  };

  Drupal.behaviors.headerLanguageDropdown = {
    attach: function(context) {
      $('.lohkanguovddas-header__language .dropbutton-widget', context).each(
        function() {
          const $widget = $(this);
          if ($widget.data('languageDropdownBound')) {
            return;
          }
          $widget.data('languageDropdownBound', true);

          const $activeLanguage = $widget.find('.active-language').first();
          if (!$activeLanguage.length) {
            return;
          }

          $activeLanguage.attr({
            tabindex: '0',
            role: 'button',
            'aria-haspopup': 'true'
          });

          $widget.on('click', function(event) {
            const $target = $(event.target);
            if ($target.closest('.dropbutton-toggle').length) {
              return;
            }

            const $activeItem = $target.closest('li');
            if (
              $activeItem.length &&
              $activeItem.find('.active-language').length
            ) {
              event.preventDefault();
              event.stopPropagation();
              $widget
                .find('.dropbutton-toggle')
                .first()
                .trigger('click');
            }
          });

          $activeLanguage.on('keydown', function(event) {
            if (event.key !== 'Enter' && event.key !== ' ') {
              return;
            }

            event.preventDefault();
            $widget
              .find('.dropbutton-toggle')
              .first()
              .trigger('click');
          });
        }
      );
    }
  };
})(Drupal, jQuery);
